import { DateTime } from 'luxon';
import { DateFormat } from '@equip.health/ui';
import {
  formatAppointmentStartEndTime,
  isoToTimezoneDateTime,
} from '../../utils';

export const formatSlotTime = (
  startIso: string,
  endIso: string,
  timezone?: string,
): string => {
  const start = isoToTimezoneDateTime(startIso, timezone);
  const end = isoToTimezoneDateTime(endIso, timezone);
  const fmt = (d: DateTime, meridiem: boolean) =>
    d
      .toFormat(meridiem ? 'h:mma' : 'h:mm')
      .toLowerCase()
      .replace(':00', '');
  const sameMeridiem = start.toFormat('a') === end.toFormat('a');
  return `${fmt(start, !sameMeridiem)} - ${fmt(end, true)}`;
};

export const timeOfDayLabel = (start: DateTime): string =>
  `${start.toFormat('h:mm')} ${start.toFormat('a').toLowerCase()}`;

export const weekMonday = (display: DateTime): DateTime =>
  display.startOf('week').startOf('day');

export const weeksBetweenMondays = (from: DateTime, to: DateTime): number =>
  Math.round(to.diff(from, 'weeks').weeks);

export const formatRangeLabel = (start: DateTime, end: DateTime): string =>
  `${start.toFormat(DateFormat.shortMonthDayNoPad)} - ${end.toFormat(DateFormat.shortMonthDayNoPad)}`;

export const formatCardDate = (iso: string, timezone?: string): string =>
  isoToTimezoneDateTime(iso, timezone).toFormat(DateFormat.shortDayMonthDateNoPad);

export const formatCardTime = (
  startIso: string,
  endIso: string,
  timezone?: string,
): string =>
  formatAppointmentStartEndTime(startIso, endIso, {
    showEndMeridiem: true,
    timezone,
  });
